/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Online_Checkin_StatusInputs */



/**
* | output |
* | --- |
* | "You're registered. Join the server to check in for the tournament." |
*
* @param {Tournament_Online_Checkin_StatusInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_online_checkin_status = /** @type {((inputs?: Tournament_Online_Checkin_StatusInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Online_Checkin_StatusInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vous êtes inscrit. Rejoignez le serveur pour pointer au tournoi.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Está inscrito. Únase al servidor para hacer check-in en el torneo.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Você está inscrito. Entre no servidor para fazer check-in no torneio.")
	if (locale === "it") return /** @type {LocalizedString} */ ("È iscritto. Acceda al server per fare check in al torneo.")
	return /** @type {LocalizedString} */ ("You're registered. Join the server to check in for the tournament.")
});